import chevronUpSrc from "@/assets/images/chevron-up@2x.png"
import colorVars from "@/assets/styles/colorVars"
import parse from "html-react-parser"
import React, { FC, useRef, useState } from "react"
import { up } from "styled-breakpoints"
import styled, { css } from "styled-components"

interface IItemElement {
  active?: boolean
}

export interface FaqItem {
  answer: string
  question: string
}

interface IFaq {
  data?: Array<FaqItem>
}

const Wrapper = styled.div``
const Item = styled.div<IItemElement>`
  position: relative;
  display: flex;
  flex-direction: column;
  justify-content: center;
  min-height: 72px;
  margin-bottom: -1px;
  color: white;
  border-top: 1px solid rgb(255 255 255 / 20%);

  &:last-of-type {
    border-bottom: 1px solid rgb(255 255 255 / 20%);
  }

  ${({ active }) =>
    active &&
    css`
      /* stylelint-disable-next-line no-duplicate-selectors */
      ${Question}::after {
        transform: rotateX(0deg);
      }

      ${Answer} {
        height: 100%;
      }
    `}
`
const Question = styled.div`
  position: relative;
  max-width: calc(100% - 16px);
  padding: 24px;
  font-size: 16px;
  font-weight: 600;
  line-height: 24px;
  color: white;
  cursor: pointer;

  ${up("md")} {
    max-width: calc(100% - 32px);
    padding: 24px;
  }

  /* Expand/collapse chevron */
  &::after {
    position: absolute;
    top: 0;
    right: 7px;
    display: block;
    width: 20px;
    height: 100%;
    content: "";
    background: url("${chevronUpSrc}") no-repeat center center;
    background-size: 20px 20px;
    transition: transform 150ms ease-in-out;
    transform: rotateX(180deg);

    ${up("md")} {
      right: -9px;
    }
  }
`
const Answer = styled.div`
  position: relative;
  padding: 0 24px 24px;
  margin-top: -24px;
  overflow: hidden;
  font-size: 16px;
  line-height: 24px;
  color: ${colorVars.text.gray};
  letter-spacing: -0.1px;
  opacity: 0;
  transition: max-height 250ms ease-in-out, opacity 250ms ease-in-out;

  > p {
    margin: 24px 0 0;
  }
`

export const Faq: FC<IFaq> = ({ data }) => {
  if (!data) return null

  // Always show the first answer, but allow showing no answer at all
  const [active, setActive] = useState<number | undefined>(0)
  const contentRef = useRef<Array<HTMLDivElement | null>>([])

  contentRef.current = contentRef.current.slice(0, data.length)

  return (
    <Wrapper>
      {data.map((item: FaqItem, index: number) => (
        <Item active={active === index} key={`item-${index}`}>
          <Question
            onClick={() => setActive(active === index ? undefined : index)}>
            {item.question}
          </Question>
          <Answer
            style={{
              maxHeight:
                active === index
                  ? `${contentRef.current[index]?.scrollHeight ?? 350}px`
                  : "0",
              opacity: active === index ? 1 : 0,
            }}
            ref={(el) => (contentRef.current[index] = el)}>
            {parse(item.answer)}
          </Answer>
        </Item>
      ))}
    </Wrapper>
  )
}
